import Layout from '@/apps/layout/components'
import Lecture from '@/apps/Lecture'
import React from 'react'

const LecturePage = (): React.ReactElement => {
  return (
    <Layout>
      <Lecture />
    </Layout>
  )
}

export default LecturePage
